import type { AgentNode } from '@onefootprint/request-types/dashboard';

/**
 * A node's label. A managed node carries none on the wire: the server derives it from the variant
 * and returns it on `nodeContext[].template.title`, which only a surface that renders managed nodes
 * reads. Until one does, the kind reads close enough to the title the server would give.
 */
const agentNodeName = (node: AgentNode): string => {
  if (node.kind !== 'managed') {
    return node.name;
  }
  const words = node.managedKind.replace(/_/g, ' ');
  return words.charAt(0).toUpperCase() + words.slice(1);
};

/**
 * Picks the wording for a node, with a third arm for the kinds this build has no word of its own
 * for. Copy that only branches on task-vs-rules calls every other kind a rules node.
 */
const byAgentNodeKind = <T>(node: AgentNode, task: T, rules: T, other: T): T => {
  if (node.kind === 'task') return task;
  if (node.kind === 'rules') return rules;
  return other;
};

export { agentNodeName, byAgentNodeKind };
